"use client";

import { c as _c } from "react/compiler-runtime";
import { parseAsJson, useQueryState } from "nuqs";
import { z } from "zod";
import { QUERY_PARAM_KEYS } from "./keys";
const schema = z.object({
  min: z.float64().optional(),
  max: z.float64().optional()
});
export function useQuantityOwnedQueryParam() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsJson(schema.parse);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [values, setValues] = useQueryState(QUERY_PARAM_KEYS.quantityOwned, t0);
  let t1;
  if ($[1] !== setValues || $[2] !== values) {
    t1 = {
      quantityOwned: values,
      setQuantityOwned: setValues
    };
    $[1] = setValues;
    $[2] = values;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}